<div (click)="outerCardTarget()" class="py-3 pl-3 pr-0 new-hcf-outer" [ngClass]= "{'new-continue-watch': (outerInfo.product_type_id === templateId.CONTINUE_WATCH)}">
  <div class="d-flex" [ngClass]="{'justify-content-between': outerInfo.target && outerInfo.target.enabled === templateStatus.ENABLE}">
    <div class="pr-3 pb-3">
      <div>
        <p *ngIf="outerInfo.title" class="overflow-wrap-anywhere heading-4">
          {{outerInfo.title}}
        </p>
        <p *ngIf="outerInfo.subtitle" class="secondary-paragraph pt-2 overflow-wrap-anywhere">
         <span class="color-grey-500">{{outerInfo.subtitle}}</span>
        </p>
      </div>
    </div>
    <div class="flex-shrink-0 pb-3" *ngIf="outerInfo.target && outerInfo.target.enabled === templateStatus.ENABLE">
      <div class="d-flex justify-content-end">
        <button
          type="button"
          class="d-flex align-items-center btn-design small outline px-md-3 mr-md-3 mr-1 justify-content-center bg-transparent"
          (click)="$event.preventDefault();$event.stopPropagation();ctaTarget(outerInfo.target)">
            {{outerInfo.target.text}}
        </button>
      </div>
    </div>
  </div>
  <ng-content></ng-content>
</div>
